import type { NextSeoProps } from "next-seo";

const description =
  "Porównaj oferty firm wykonujących przeglądy instalacji elektrycznych, gazowych, kominowych, wentylacyjnych, PPOŻ i budowlanych w całej Polsce.";
const defaultTitle =
  "Inspektomat - przeglądy bezpieczeństwa instalacji i budynków";

export const DEFAULT_SEO: NextSeoProps = {
  description: description,
  themeColor: "#fafafa",
  titleTemplate: "%s - inspektomat.pl",
  defaultTitle: defaultTitle,
  additionalMetaTags: [
    {
      name: "keywords",
      content:
        "przegląd instalacji, przegląd instalacji elektrycznej, przegląd instalacji gazowej, przegląd kominiarski, przegląd wentylacji, przegląd ppoż, przegląd budowlany, obowiązkowe przeglądy budynków, bezpieczeństwo instalacji",
    },
  ],
  openGraph: {
    type: "website",
    locale: "pl_PL",
    url: "https://inspektomat.pl/",
    title: defaultTitle,
    description: description,
    siteName: "Inspektomat",
  },
};
